var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCollateral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 50C11.6929 50 0.5 38.8071 0.5 25C0.5 11.1929 11.6929 0 25.5 0C39.3071 0 50.5 11.1929 50.5 25C50.5 38.8071 39.3071 50 25.5 50Z",
    fill: "#27490F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5745 16.273L16.773 34.0745L34.5745 16.273Z",
    fill: "#27490F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5745 16.273L16.773 34.0745",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8548 18.1774C21.8548 19.9323 20.4323 21.3548 18.6774 21.3548C16.9226 21.3548 15.5 19.9323 15.5 18.1774C15.5 16.4226 16.9226 15 18.6774 15C20.4323 15 21.8548 16.4226 21.8548 18.1774Z",
    fill: "#27490F",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8475 32.1651C35.8475 33.9227 34.4227 35.3475 32.6651 35.3475C30.9075 35.3475 29.4827 33.9227 29.4827 32.1651C29.4827 30.4075 30.9075 28.9827 32.6651 28.9827C34.4227 28.9827 35.8475 30.4075 35.8475 32.1651Z",
    fill: "#27490F",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCollateral);
export default __webpack_public_path__ + "static/media/no-collateral.e51412fa7b86dddb1789f8340b04b885.svg";
export { ForwardRef as ReactComponent };